import React, { useEffect, useState, useRef } from "react";
import * as SettingSelector from "../../../../store/setting/selectors";
import { useSelector } from "react-redux";
import { useLocation } from "react-router-dom";

import Verticalnav from "./verticalnav";
import Scrollbar from "smooth-scrollbar";
import { Link } from "react-router-dom";
import logo from "../../../../assets/images/logo/logo.png";
import { FaChevronLeft } from "react-icons/fa6";

const Sidebar = () => {
  const sidebarType = useSelector(SettingSelector.sidebar_type);
  const sidebarMenuStyle = useSelector(SettingSelector.sidebar_menu_style);
  const appName = useSelector(SettingSelector.app_name);

  const [isSidebarOpen, setIsSidebarOpen] = useState(true);
  const sidebarRef = useRef(null);
  const location = useLocation();

  const isMobile = () => window.innerWidth < 1025;

  const minisidebar = () => {
    if (sidebarRef.current) {
      sidebarRef.current.classList.toggle("sidebar-mini");
    }
    setIsSidebarOpen((prev) => !prev);
  };

  useEffect(() => {
    Scrollbar.init(document.querySelector(".data-scrollbar"));
    const handleResize = () => {
      if (sidebarRef.current) {
        const width = window.innerWidth;
        const shouldCollapse = width < 1025;
        const hasMini = sidebarRef.current.classList.contains("sidebar-mini");

        if (shouldCollapse && !hasMini) {
          sidebarRef.current.classList.add("sidebar-mini", "on-resize");
          setIsSidebarOpen(false);
        } else if (
          !shouldCollapse &&
          hasMini &&
          sidebarRef.current.classList.contains("on-resize")
        ) {
          sidebarRef.current.classList.remove("sidebar-mini", "on-resize");
          setIsSidebarOpen(true);
        }
      }
    };

    handleResize();
    window.addEventListener("resize", handleResize);

    // 👇 Detect outside click and close sidebar on mobile
    const handleClickOutside = (event) => {
      if (
        isMobile() &&
        sidebarRef.current &&
        !sidebarRef.current.contains(event.target)
      ) {
        if (!sidebarRef.current.classList.contains("sidebar-mini")) {
          sidebarRef.current.classList.add("sidebar-mini", "on-resize");
          setIsSidebarOpen(false);
        }
      }
    };
    // console.log(sidebarRef)
    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      window.removeEventListener("resize", handleResize);
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const handleNavLinkClick = () => {
    if (
      isMobile() &&
      sidebarRef.current &&
      !sidebarRef.current.classList.contains("sidebar-mini")
    ) {
      sidebarRef.current.classList.add("sidebar-mini", "on-resize");
      setIsSidebarOpen(false);
    }
  };

  return (
    <aside
      ref={sidebarRef}
      className={`${sidebarType.join(" ")} ${sidebarMenuStyle} sidebar sidebar-default sidebar-base navs-rounded-all sidebar-slim`}
      //sidebar-mini
      id="first-tour"
      data-toggle="main-sidebar"
      data-sidebar="responsive"
    >
      <div className="sidebar-header d-flex align-items-center justify-content-start position-relative ">
        <Link
          to="/"
          className="d-flex align-items-center gap-2 iq-header-logo py-1"
        >
          <img src={logo} alt="logo" className="" style={{ height: "32px" }} />
        </Link>
        <div
          className="sidebar-toggle mt-2"
          data-toggle="sidebar"
          data-active="true"
          onClick={minisidebar}
        >
          <span className="menu-btn d-inline-flex align-items-center is-active">
            {/* <i className="right-icon material-symbols-outlined icon-rtl">
              chevron_left
            </i> */}
            <FaChevronLeft className="right-icon icon-rtl text-black-50" />
          </span>
        </div>
      </div>
      <div className="sidebar-body pt-0 data-scrollbar mt-2 mt-lg-4">
        <div className="sidebar-list">
          <Verticalnav
            isSidebarOpen={isSidebarOpen}
            onLinkClick={handleNavLinkClick}
          />
        </div>
      </div>
      <div className="sidebar-footer"></div>

      {/* Narrower sidebar width override — adjust the two px values below
          to taste. Kept scoped to .sidebar-slim so nothing else in the
          template's stylesheet is touched. */}
      <style>{`
        .sidebar-slim {
          width: 220px !important;
        }
        .sidebar-slim.sidebar-mini {
          width: 64px !important;
        }
      `}</style>
    </aside>
  );
};

export default Sidebar;
